import Icons, { IconsProps } from '../Icons';

// Out of Stock
export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
          d="M22 12.5356L10 5.61562M4.35997 9.28202L16 16.0153L27.64 9.28202M16 29.4423V16.0023M28 21.3358V10.6691C27.9995 10.2015 27.876 9.74221 27.6421 9.33735C27.408 8.93248 27.0717 8.59629 26.6667 8.36247L17.3333 3.02914C16.928 2.79509 16.4682 2.67188 16 2.67188C15.5319 2.67188 15.072 2.79509 14.6667 3.02914L5.33333 8.36247C4.92835 8.59629 4.59197 8.93248 4.35795 9.33735C4.12392 9.74221 4.00048 10.2015 4 10.6691V21.3358C4.00048 21.8035 4.12392 22.2627 4.35795 22.6676C4.59197 23.0724 4.92835 23.4086 5.33333 23.6425L14.6667 28.9758C15.072 29.2099 15.5319 29.3331 16 29.3331C16.4682 29.3331 16.928 29.2099 17.3333 28.9758L26.6667 23.6425C27.0717 23.4086 27.408 23.0724 27.6421 22.6676C27.876 22.2627 27.9995 21.8035 28 21.3358Z"
          stroke="#212121"
          stroke-width="1.33333"
        />
      </svg>
    </Icons>
  );
}
